import { FamilyMember } from '@/types';
import { TreeNode } from './TreeNode';

interface TreeNodesProps {
  members: FamilyMember[];
  nodePositions: Map<string, { x: number; y: number }>;
  nodeWidth: number;
  nodeHeight: number;
  onEditNode?: (member: FamilyMember) => void;
  onDeleteNode?: (member: FamilyMember) => void;
  onAddChild?: (member: FamilyMember) => void;
  isAdmin: boolean;
}

export function TreeNodes({
  members,
  nodePositions,
  nodeWidth,
  nodeHeight,
  onEditNode,
  onDeleteNode,
  onAddChild,
  isAdmin,
}: TreeNodesProps) {
  return (
    <>
      {members.map(member => {
        const position = nodePositions.get(member.id);
        if (!position) return null;

        return (
          <foreignObject
            key={member.id}
            x={position.x}
            y={position.y}
            width={nodeWidth}
            height={nodeHeight}
          >
            <TreeNode 
              member={member}
              onEdit={() => onEditNode?.(member)}
              onDelete={() => onDeleteNode?.(member)}
              onAddChild={() => onAddChild?.(member)}
              isAdmin={isAdmin}
            />
          </foreignObject>
        );
      })}
    </>
  );
}